<template>
  <div class="field">
    <label class="label">Current Company</label>
    <div class="control">
      <input
        class="input has-text-right"
        dir="rtl"
        type="text"
        placeholder="..."
        :value="value"
        @input="updateValue"
        @focusout="handleChange"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'CurrentCompany',
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    applicantId: {
      type: Number,
      required: true
    }
  },
  methods: {
    updateValue (event) {
      this.$emit('input', event.target.value)
    },
    async handleChange () {
      try {
        await this.$network_utils.updateApplicant({ applicant_id: this.applicantId, current_company: this.value })
        this.$utils.emit('show_toast', { text: 'Success' })
      } catch (e) {
        this.$utils.emit('show_toast', { text: 'failed' })
      }
    }
  }
}
</script>
